export default __webpack_public_path__ + "static/media/CODIGO_DE_ETICA.0b58ae8a.pdf";